import { VaccinationCategory } from "./VaccinationCategory";

export function VaccinationDetailsArray(vaccination, t) {
  if (!vaccination) return [];
  const commonDetails = [
    {
      title: t("Name"),
      value: vaccination.name || null,
    },
  ];

  if (vaccination.vaccinationCategory === VaccinationCategory.RABIES) {
    return [
      ...commonDetails,
      {
        title: t("SerialNumber"),
        value: vaccination.serialNumber,
      },
      {
        title: t("DateOfApplication"),
        value: vaccination.dateOfApplication,
      },
      {
        title: t("IsFirstRabiesVaccine"),
        value: vaccination.isFirstRabiesVaccine ? t("Yes") : t("No"),
      },
      {
        title: t("ImmunityPeriod"),
        value: vaccination.immunityPeriod
          ? `${vaccination.immunityPeriod} ${
              vaccination.immunityPeriod === 1 ? t("SingleYear") : t("PluralYear")
            }`
          : null,
      },
      {
        title: t("ImmunityFrom"),
        value: vaccination.immunityFromDate,
      },
      {
        title: t("ImmunityTo"),
        value: vaccination.immunityToDate,
      },
      {
        title: t("ExpirationDate"),
        value: vaccination.expirationDate,
      },
      {
        title: t("Description"),
        value: vaccination.description,
      },
    ];
  } else if (vaccination.vaccinationCategory === VaccinationCategory.OTHER) {
    return [
      ...commonDetails,
      {
        title: t("Lot"),
        value: vaccination.lot,
      },
      ...(vaccination.powderExpirationDate
        ? [
            {
              title: t("PowderExpirationDate"),
              value: vaccination.powderExpirationDate,
            },
          ]
        : []),
      ...(vaccination.solventExpirationDate
        ? [
            {
              title: t("SolventExpirationDate"),
              value: vaccination.solventExpirationDate,
            },
          ]
        : []),
      ...(vaccination.dateOfApplication
        ? [
            {
              title: t("DateOfApplication"),
              value: vaccination.dateOfApplication,
            },
          ]
        : []),
      ...(vaccination.expirationDate
        ? [
            {
              title: t("ExpirationDate"),
              value: vaccination.expirationDate,
            },
          ]
        : []),
    ];
  }
  return [];
}
